<template>
  <div class="item">
    <div v-for="(item,index) in data" :key="index" class="card-item" @click="routeTo(item)">
      <div class="top">
        <div class="title">
          报告信息
        </div>
        <div class="card">
          {{ item.sourceName }}
        </div>
      </div>
      <div class="row">
        <div class="left">
          报告单号：
        </div>
        <div class="right">
          {{ item.inspectNo }}
        </div>
      </div>
      <div class="row">
        <div class="left">
          报告类型：
        </div>
        <div class="right">
          {{ item.inspectType }}
        </div>
      </div>
      <div class="row">
        <div class="left">
          就诊人：
        </div>
        <div class="right">
          {{ item.patName }}
        </div>
      </div>
      <div class="row">
        <div class="left">
          报告日期：
        </div>
        <div class="right">
          {{ item.reportTime }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  name: 'CheckoutItem',
  props: {
    data:{
      type:Array,
      default: () => ([])
    },
    patId:{
      type:String,
      default: ''
    }
  },
  methods: {
    routeTo(item) {
      this.$router.push('/checkoutdetail?patId='+this.patId+'&bgdh='+item.inspectNo)
    }
  }
}
</script>
<style scoped lang='less'>
@import "../../assets/styles/variable.less";

.item {

  .card-item {
    width: 100%;
    background: #FFFFFF;
    border-radius: 12px;
    margin-bottom: 24px;
    padding: 24px 32px;
    box-sizing: border-box;

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      .title {
        font-size: 32px;
        font-weight: bold;
        color: #3D3D3D;
      }
      .card {
        background-color: rgba(58, 138, 229, 0.15);
        color: #3A8AE5;
        text-align: center;
        padding: 3px 8px;
        border-radius: 4px;
      }
    }

    .row {
      display: flex;
      line-height: 40px;
      justify-content: space-between;
      font-size: 28px;
      margin-bottom: 24px;

      .left {
        text-align: left;
        color: #666666;
      }

      .right {
        text-align: right;
        color: #333333;
      }
    }
  }
}

</style>
